import React from "react";

export const ProductDetailsLoading = () => {
  return (
    <>
      {/* Carousel */}
      <div className="skeleton h-[16rem] md:col-span-2" />
      {/* Info */}
      <div className="skeleton h-[16rem]" />
      {/* Description */}
      <div className="skeleton h-[8rem] md:col-span-3" />
      {/* Attributes */}
      <div className="skeleton h-[8rem] md:col-span-2" />
      {/* Reviews */}
      <div className="skeleton h-[16rem]" />
      {/* Delivery */}
      <div className="skeleton h-[8rem] md:col-span-3" />
      {/* Similar items */}
      <div className="skeleton h-[8rem] md:col-span-3" />
      {/* Favorite items */}
      <div className="skeleton h-[8rem] md:col-span-3" />
      {/* Contact us */}
      <div className="grid gap-2 md:col-span-3 md:grid-cols-2 md:gap-4">
        <div className="skeleton h-[8rem]" />
        <div className="skeleton h-[8rem]" />
      </div>
    </>
  );
};
